'use client';

import styled from 'styled-components';
import { MetricCard } from './MetricCard';
import { MetricData } from '@/types/metrics';

interface MetricGridProps {
  metrics: MetricData[];
  loading?: boolean;
  className?: string;
}

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(220px, 1fr));
  gap: 20px;
  width: 100%;

  margin-bottom: 20px;
  @media (max-width: 1400px) {
    grid-template-columns: repeat(3, minmax(220px, 1fr));
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(220px, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const MetricGrid: React.FC<MetricGridProps> = ({ metrics, loading = false, className }) => {
  if (loading) {
    // Render skeleton metric cards
    return (
      <GridContainer className={className}>
        {[1, 2, 3, 4, 5].map((i) => (
          <MetricCard
            key={`skeleton-${i}`}
            title=""
            value=""
            loading={true}
          />
        ))}
      </GridContainer>
    );
  }

  return (
    <GridContainer className={className}>
      {metrics.map((metric) => (
        <MetricCard
          key={metric.id}
          title={metric.title}
          value={metric.value}
          unit={metric.unit}
          change={metric.change}
          variant={metric.variant}
        />
      ))}
    </GridContainer>
  );
};
